import { FlowComponentDefinition } from "../../interface/functionalityInterface";
import { OUTLINE_COLOR } from "./renderingUtils";

export const bendComponent: FlowComponentDefinition = {
  type: "bend",
  title: "bend",
  category: "Pipes & Fittings",
  visualKind: "bend",
  defaultColor: "#9ea4ab",
  previewFlow: { from: "left", to: "down" },
  ports: ["left", "down"],
  incomingDirections: ["left"],
  outgoingDirections: ["down"],
  defaults: { diameter: "100", radius: "150", angle: "90" },
  fields: [
    { key: "diameter", label: "Diameter" },
    { key: "radius", label: "Radius" },
    { key: "angle", label: "Angle" },
    { key: "color", label: "Color", inputType: "color" },
  ],
  renderGraphic: ({ startPoint, endPoint, componentColor, arrowColor, node }) => {
    const arrowPoints =
      node.flow.to === "right"
        ? "96,50 84,43 84,57"
        : node.flow.to === "left"
          ? "4,50 16,43 16,57"
          : node.flow.to === "up"
            ? "50,4 43,16 57,16"
            : "50,96 43,84 57,84";

    return (
      <>
        <polyline
          points={`${startPoint.x},${startPoint.y} 50,50 ${endPoint.x},${endPoint.y}`}
          fill="none"
          stroke={OUTLINE_COLOR}
          strokeWidth="20"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <polyline
          points={`${startPoint.x},${startPoint.y} 50,50 ${endPoint.x},${endPoint.y}`}
          fill="none"
          stroke={componentColor}
          strokeWidth="15"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <polyline
          points={`${startPoint.x},${startPoint.y} 50,50 ${endPoint.x},${endPoint.y}`}
          fill="none"
          stroke={OUTLINE_COLOR}
          strokeWidth="2.2"
          strokeLinejoin="round"
          strokeLinecap="round"
        />
        <polygon points={arrowPoints} fill={arrowColor} />
      </>
    );
  },
  renderAnimatedFlow: ({ startPoint, endPoint, pulseColor }) => (
    <polyline
      points={`${startPoint.x},${startPoint.y} 50,50 ${endPoint.x},${endPoint.y}`}
      fill="none"
      stroke={pulseColor}
      strokeWidth="11"
      strokeLinejoin="round"
      strokeLinecap="round"
    />
  ),
};
